// extracted by css-extract-rspack-plugin
export default {"paperContainer":"src-domain-components-create-resource-modal-CreateResourceModal-module__paperContainer-tBdFza","modalContent":"src-domain-components-create-resource-modal-CreateResourceModal-module__modalContent-VT0YNt","modalActions":"src-domain-components-create-resource-modal-CreateResourceModal-module__modalActions-INYV0k"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"paperContainer\":\"src-domain-components-create-resource-modal-CreateResourceModal-module__paperContainer-tBdFza\",\"modalContent\":\"src-domain-components-create-resource-modal-CreateResourceModal-module__modalContent-VT0YNt\",\"modalActions\":\"src-domain-components-create-resource-modal-CreateResourceModal-module__modalActions-INYV0k\"}";
        // 1792611262677
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  